import { QriDetailsV2, hasDisplayLabelProperty } from '@qualio/search-qri';

export function formResolvedQriDisplayText(qriDetails: QriDetailsV2) {
  return hasDisplayLabelProperty(qriDetails) ? qriDetails.displayLabel : '';
}
